import { put, all, call, takeLatest, select } from 'redux-saga/effects';
import {
  requestLoginFailure,
  requestLoginSuccess,
  actionNames,
  logoutSuccess,
  requestLoginWithSessionIdSuccess,
  requestLoginWithSessionIdFailure,
} from './actions';

import {
  login,
  loginWithSessionId,
  laravelLoginWlWithToken,
  laravelLoginWithToken,
  logoutHeimdallBFF,
  loginWithToken,
} from '../../../services/auth/login';

import {
  getFoundationAllowed,
  getUserDataFromToken,
} from '../../../services/auth/heimdall/login';

import { setCurrentCustomerId } from '../general/actions';
import { clearKeepAliveInterval } from 'src/utils/keepAlive';
import { localStorageService } from 'src/services/local-storage.service';

function* loginRequest(event) {
  try {
    let result = yield call(login, event.payload);

    if (!result.token) {
      throw new Error('Token not received!');
    }

    const token = result.token;
    let current_customer_id = result.user.customers[0];

    const whiteLabelState = yield select((state) => state?.whitelabel);

    if (whiteLabelState?.config && whiteLabelState?.config.is_white_label) {
      if (!whiteLabelState.config.laravel_url)
        throw new Error('URL não fornecida para autenticação!');
      yield call(
        laravelLoginWlWithToken,
        { token, session_id: result.session_id },
        current_customer_id,
        whiteLabelState.config.laravel_url
      ); //Faz login no laravel, selecionando primeira empresa
    } else {
      yield call(
        laravelLoginWithToken,
        { token, session_id: result.session_id },
        current_customer_id
      ); //Faz login no laravel, selecionando primeira empresa
    }

    yield put(setCurrentCustomerId(current_customer_id)); //Adiciona no redux a empresa logada

    window.localStorage.setItem('poli_access', JSON.stringify(result));
    yield put(requestLoginSuccess(result));
    const foundationAllowed = yield call(getFoundationAllowed);
    if (foundationAllowed) {
      window.location.assign(foundationAllowed);
      return;
    }
  } catch (e) {
    console.error('login error', e);
    yield put(requestLoginFailure(e));
  }
}

function* loginRequestWithSessionId(event) {
  try {
    let result = yield call(loginWithSessionId, event.payload);

    // Verifica se houve erro na resposta
    if (result?.error || !result?.token) {
      throw new Error(result?.message || 'Token not received!');
    }

    // Verifica se os dados do usuário estão presentes e válidos
    if (
      !result?.user ||
      !result.user.customers ||
      !Array.isArray(result.user.customers) ||
      result.user.customers.length === 0
    ) {
      console.error('Dados do usuário inválidos no result:', result);
      throw new Error('Dados do usuário inválidos ou sem customers!');
    }

    // NÃO sobrescreve o user_token_login_info aqui, pois já foi salvo corretamente
    // em HeimdallBFFLoginWithSessionId com todos os dados (token, refresh_token, etc)
    // O result aqui só tem token (legacy_token), user e session_id, não tem refresh_token

    const token = result.token;
    let current_customer_id = result.user.customers[0];

    const whiteLabelState = yield select((state) => state?.whitelabel);

    if (whiteLabelState?.config && whiteLabelState?.config.is_white_label) {
      if (!whiteLabelState.config.laravel_url)
        throw new Error('URL não fornecida para autenticação!');
      yield call(
        laravelLoginWlWithToken,
        { token, session_id: result.session_id },
        current_customer_id,
        whiteLabelState.config.laravel_url
      ); //Faz login no laravel, selecionando primeira empresa
    } else {
      yield call(
        laravelLoginWithToken,
        { token, session_id: result.session_id },
        current_customer_id
      ); //Faz login no laravel, selecionando primeira empresa
    }

    yield put(setCurrentCustomerId(current_customer_id)); //Adiciona no redux a empresa logada

    window.localStorage.setItem('poli_access', JSON.stringify(result));
    yield put(requestLoginSuccess(result));
    yield put(requestLoginWithSessionIdSuccess());
  } catch (e) {
    console.error('login error', e);
    yield put(requestLoginWithSessionIdFailure(e));
  }
}

//Login via token pela URL
function* loginRequestWl(event) {
  try {
    let result = yield call(loginWithToken, event.payload);

    if (!result.token) {
      throw new Error('Token not received!');
    }

    if ('token' in result) {
      const userData = yield call(getUserDataFromToken, result.token, true);

      if (
        !userData.user ||
        !userData.user.customers ||
        userData.user.customers.length === 0
      ) {
        throw new Error('Dados do usuário não encontrados ou inválidos!');
      }

      const access = {
        token: result.legacy_token,
        user: userData.user,
      };
      let current_customer_id = userData.user.customers[0];

      const getStateConfig = (state) => state?.whitelabel?.config;
      const whitelabelConfig = yield select(getStateConfig);

      if (!whitelabelConfig?.laravel_url)
        throw new Error('URL não fornecida para autenticação!');

      yield call(
        laravelLoginWlWithToken,
        { token: result.legacy_token },
        current_customer_id,
        whitelabelConfig.laravel_url
      ); //Faz login no laravel, selecionando primeira empresa

      yield put(setCurrentCustomerId(current_customer_id)); //Adiciona no redux a empresa logada

      window.localStorage.setItem('poli_access', JSON.stringify(access));
      localStorageService.setLocalStorageItem({
        key: 'user_token_login_info',
        value: 'legacy_token' in result ? result : null,
      });
      yield put(requestLoginSuccess(access));
      event.payload.successFn();
    }
  } catch (e) {
    console.error('login error', e);
    yield put(requestLoginFailure(e));
    event.payload.errorFn();
  }
}

function* logoutRequest(event) {
  try {
    // Remove poli_access mas mantém user_token_login_info para permitir refresh_token se necessário
    window.localStorage.removeItem('poli_access');
    window.localStorage.removeItem('spa_current_customer_id');

    yield call(logoutHeimdallBFF);

    clearKeepAliveInterval();

    yield put(logoutSuccess());
  } catch (e) {
    console.error('logout error', e);
  }
}

function* revokeToken() {
  try {
    const wsState = (state) => state.chat.socket;
    const passiveWsState = (state) => state.chat.passiveSocket;
    const websocket = yield select(wsState);
    const passiveWebsocket = yield select(passiveWsState);
    const message = JSON.stringify({
      subject: 'revoke_token',
    });

    websocket?.sendMessage(message);
    passiveWebsocket?.sendMessage(message);
  } catch (error) {
    console.error(error);
  }
}

export default all([
  takeLatest(actionNames.REQUEST_LOGIN, loginRequest),
  takeLatest(
    actionNames.REQUEST_LOGIN_WITH_SESSIONID,
    loginRequestWithSessionId
  ),
  takeLatest(actionNames.REQUEST_LOGIN_WL, loginRequestWl),
  takeLatest(actionNames.LOGOUT, logoutRequest),
  takeLatest(actionNames.REVOKE_TOKEN, revokeToken),
]);
